import axios from '../shared/axios';

export function saveBankAccount(data) {
    return axios.post(`/api/BankAccount/SaveBankAccount`, data);
}

export function getBankAccounts(companyid, projectid, contractid) {
    return axios.post(`/api/BankAccount/LoadBankAccountsList?companyid=${companyid}&projectid=${projectid}&contractid=${contractid}`);
}
